import generateActionTypeNames from "../utils/generateActionTypeNames";

let types = {
  REQUEST_REISADVIEZEN: null,
  REQUEST_REISADVIEZEN_FAILED: null,
  RECEIVED_REISADVIEZEN: null,
  REQUEST_FLEX_REISADVIEZEN: null,
  REQUEST_FLEX_REISADVIEZEN_FAILED: null,
  RECEIVED_FLEX_REISADVIEZEN: null,
  SELECTED_REISADVIES: null,
  REQUEST_DIENSTREGELING: null,
  REQUEST_DIENSTREGELING_FAILED: null,
  RECEIVED_DIENSTREGELING: null,
  SET_DIENSTREGELING_DIRECTION: null,
  REQUEST_DIENSTREGELING_DISRUPTIONS: null,
  RECEIVED_DIENSTREGELING_DISRUPTIONS: null,
  REQUEST_DIENSTREGELING_DISRUPTIONS_FAILED: null,
  REQUEST_STORINGEN: null,
  REQUEST_STORINGEN_FAILED: null,
  RECEIVED_STORINGEN: null,
  SELECTED_STORING: null,
  REQUEST_STOPS: null,
  REQUEST_STOPS_FAILED: null,
  RECEIVED_STOPS: null,
  SELECTED_STOPS: null,
  REQUEST_STOPINFO: null,
  REQUEST_STOPINFO_FAILED: null,
  RECEIVED_STOPINFO: null,
  SELECTED_STOPINFO: null,
  START_REFRESH_INTERVAL_STOPINFO: null,
  ABORT_REFRESH_INTERVAL_STOPINFO: null,
  REFRESH_STOPINFO: null,
  REQUEST_PRODUCTS: null,
  REQUEST_PRODUCTS_FAILED: null,
  RECEIVED_PRODUCTS: null,
  PRODUCTS_FILTERS_CHANGED: null,
  REQUEST_REISADVIEZEN_NEXT: null,
  REQUEST_REISADVIEZEN_PREV: null,
  RECEIVED_REISADVIEZEN_NEXT: null,
  RECEIVED_REISADVIEZEN_PREV: null,
  REQUEST_BEFORE_MIDNIGHT: null,
  SET_REACHED_END_OF_DAY: null,
  SET_REACHED_START_OF_DAY: null,
  SET_REQUEST_VALUES: null,
  DIENSTREGELING_LOADING: null,
};

types = generateActionTypeNames(types);
export default types;



// WEBPACK FOOTER //
// ./src/actions/types.js